export default "__VITE_ASSET__CUCwdXQk__"